// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)
import { useLocation } from 'react-router-dom';
import { useBrand } from '@/hooks/useBrand';
import { usePlatformStore } from '@/store/platformStore';
import { sektorPaketiMi } from '@/components/menuTanimi';

const UYGULAMA_KODU = /^[a-z][a-z0-9-]{1,39}$/;

/** Gecerli bir uygulama kodu mu? Core modulu (core.finance) ve sektor/ulke paketi uygulama degildir. */
export function uygulamaKoduMu(kod: string | null | undefined): kod is string {
  return !!kod && UYGULAMA_KODU.test(kod) && !sektorPaketiMi(kod);
}

/**
 * Ekranin ait oldugu uygulama (smarterp, eportal, cxcentral…). Ortak kabuk kodunda urun adi
 * sabit yazilmaz; kod buradan gelir. Sira: izole urunun alt alani (kesin bilgi) → acik rotadaki
 * uygulama (/entity/{app}/…, /{app}/…) → kalici aktif uygulama. Hicbiri gecerli degilse bos doner;
 * cagiran taraf o zaman uygulamaya ozgu baglantiyi gostermez.
 */
export function useAktifUygulama(): string {
  const brand = useBrand();
  const { pathname } = useLocation();
  const depo = usePlatformStore((s) => s.currentApp);
  const izole = brand.navIsolated ? (brand.subdomain ?? '').toLowerCase() : '';
  if (uygulamaKoduMu(izole)) return izole;
  const yol = pathname.toLowerCase();
  const rotadan = /^\/entity\/([^/]+)\//.exec(yol)?.[1] ?? /^\/([^/]+)\/support\//.exec(yol)?.[1];
  if (uygulamaKoduMu(rotadan)) return rotadan;
  const d = (depo ?? '').toLowerCase();
  return uygulamaKoduMu(d) ? d : '';
}
